import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../components/ProtectedRoute'
import PlanUpgradeModal from '../components/PlanUpgradeModal'

interface PlanGuardProps {
  children: React.ReactNode
  requiredPlan?: 'growth' | 'scale' | 'enterprise'
  redirectTo?: string
}

const PlanGuard: React.FC<PlanGuardProps> = ({
  children,
  requiredPlan = 'growth',
  redirectTo = '/dashboard',
}) => {
  const navigate = useNavigate()
  const { user, isAuthenticated } = useAuth()
  const [showUpgradeModal, setShowUpgradeModal] = React.useState(false)

  const planHierarchy = {
    starter: 0,
    growth: 1,
    scale: 2,
    enterprise: 3,
  }

  const hasRequiredPlan = () => {
    if (!user) {
      return false
    }

    // 사용자의 플랜 정보를 다양한 경로에서 확인
    let userPlan = user.subscription?.plan || user.plan || 'starter'

    // 문자열을 소문자로 변환
    userPlan = userPlan.toLowerCase()

    console.log('Current user plan:', userPlan, 'Required plan:', requiredPlan)
    console.log('User object:', user)

    const userPlanLevel =
      planHierarchy[userPlan as keyof typeof planHierarchy] ?? 0
    const requiredPlanLevel = planHierarchy[requiredPlan]

    return userPlanLevel >= requiredPlanLevel
  }

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true })
      return
    }

    if (!hasRequiredPlan()) {
      setShowUpgradeModal(true)
    }
  }, [isAuthenticated, user, navigate])

  const handleUpgradeModalClose = () => {
    setShowUpgradeModal(false)
    navigate(redirectTo, { replace: true })
  }

  const handleUpgrade = () => {
    navigate('/price', { replace: true })
  }

  // 로그인하지 않은 경우
  if (!isAuthenticated) {
    return null
  }

  // 플랜이 부족한 경우
  if (!hasRequiredPlan()) {
    return (
      <PlanUpgradeModal
        isOpen={showUpgradeModal}
        onClose={handleUpgradeModalClose}
        onUpgrade={handleUpgrade}
        requiredPlan={requiredPlan}
        currentPlan={user?.subscription?.plan || 'starter'}
        feature="팀 협업"
      />
    )
  }

  // 권한이 있는 경우 컴포넌트 렌더링
  return <>{children}</>
}

export default PlanGuard
